/**
 * Product Media Info Strip
 * Handles popup toggle for "Mehr Infos" buttons
 */
document.addEventListener('DOMContentLoaded', () => {
  const strips = document.querySelectorAll('[data-info-strip]');

  strips.forEach((strip) => {
    const toggleBtn = strip.querySelector('[data-info-strip-toggle]');
    const popup = strip.querySelector('[data-info-strip-popup]');
    const closeBtn = strip.querySelector('[data-info-strip-close]');

    if (!toggleBtn || !popup) return;

    const isOpen = () => popup.getAttribute('aria-hidden') === 'false';

    const openPopup = () => {
      popup.setAttribute('aria-hidden', 'false');
      strip.classList.add('info-strip--popup-open');
    };

    const closePopup = () => {
      popup.setAttribute('aria-hidden', 'true');
      strip.classList.remove('info-strip--popup-open');
    };

    const closeAllOthers = () => {
      document.querySelectorAll('[data-info-strip-popup][aria-hidden="false"]').forEach((p) => {
        if (p !== popup) {
          p.setAttribute('aria-hidden', 'true');
          p.closest('[data-info-strip]').classList.remove('info-strip--popup-open');
        }
      });
    };

    // Toggle on "Mehr Infos" click
    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeAllOthers();
      if (isOpen()) {
        closePopup();
      } else {
        openPopup();
      }
    });

    // Close on X button
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closePopup();
      });
    }

    // Close on click anywhere on the strip (but not the popup itself)
    strip.addEventListener('click', (e) => {
      if (isOpen() && !popup.contains(e.target) && !toggleBtn.contains(e.target)) {
        closePopup();
      }
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (isOpen() && !strip.contains(e.target)) {
        closePopup();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) {
        closePopup();
      }
    });
  });
});
